import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const getSweepstakeDrawingInfoQueryKey = (id: number) =>
  ['/sweepstakes', id, 'drawing-info'] as const

export const useGetSweepstakeByIdWithDrawingInfo = (id: number) => {
  const get = useTypedApiClient({
    path: '/admin/contests/{id}/drawing-info',
    method: 'get',
  })

  return useQuery({
    queryKey: getSweepstakeDrawingInfoQueryKey(id),
    queryFn: async () => {
      const { data } = await get({ id })
      return data
    },
  })
}
